export enum PaymentMethodTestHooks {
  Form = 'payment-method-form',
  PaymentTypeRadio = 'payment-type-radio',
}
